/**
 * Brew's free, no-login tools. The ONE list the marketing nav, footer,
 * sitemap and llms.txt read, so adding a tool here is what publishes it
 * everywhere. Plain strings only: the client nav and the server sitemap both
 * import this module.
 */

export type FreeToolId = 'email-audit'

/**
 * The organization a free run is attributed to in AI Gateway tags and logs.
 * Like `'forwarded'` and `'system'`, a placeholder: no org owns the run.
 */
export const FREE_TOOLS_ORG_ID = 'free-tools'

/** How long a free tool's shared report link keeps working. */
export const FREE_TOOL_REPORT_TTL_DAYS = 30

export type FreeTool = {
  id: FreeToolId
  /** The tool's public page. */
  path: `/${string}`
  /** Short name for nav rows and footer links. */
  name: string
  /** One line under the name in the nav menu. */
  description: string
}

export const FREE_TOOLS: ReadonlyArray<FreeTool> = [
  {
    id: 'email-audit',
    path: '/email-audit',
    name: 'Free email audit',
    description: 'Grade any email before you send it',
  },
]

export function getFreeTool(id: FreeToolId): FreeTool {
  const tool = FREE_TOOLS.find((candidate) => candidate.id === id)
  if (!tool) {
    throw new Error(`Unknown free tool: ${id}`)
  }
  return tool
}
